export const location = {
  pathname: '/regulars',
};

export const SUBSCRIPTIONS_COOKIE_EXPIRATION_MONTHS = 6;
export const SUBSCRIPTIONS_MINIMAL_PLACED_ORDER_COUNT = 4;
export const SUBSCRIPTIONS_REGULAR_PLACED_ORDER_COUNT = 3;

